import { render, staticRenderFns } from "./sdproduct6.vue?vue&type=template&id=59e9a877&scoped=true"
import script from "./sdproduct6.vue?vue&type=script&lang=js"
export * from "./sdproduct6.vue?vue&type=script&lang=js"
import style0 from "./sdproduct6.vue?vue&type=style&index=0&id=59e9a877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e9a877",
  null
  
)

export default component.exports